
var selectLess = {};
import genaration from '../../utils/classname';
export var selectClass = genaration(selectLess, 'select');